import React from 'react';
import { Body, Heading, SwipeableDrawer } from '../UI';
import { IconBarcodeScanner, IconQrCode, IconScanShipping } from '../Icons';
import styles from './styles.module.scss';

interface BarcodeInfoDrawer {
    open: boolean;
    onOpen: () => void;
    onClose: () => void;
}

function BarcodeInfoDrawer(props: BarcodeInfoDrawer) {
    return (
        <SwipeableDrawer
            anchor="bottom"
            {...props}
            id={'barcode-scanner-info-drawer'}
            classes={{ paper: styles.paper, root: styles.root }}
        >
            <ul className={styles.infoListContainer}>
                <li>
                    <IconBarcodeScanner height={24} width={24} />
                    <Heading type="h6" size={16}>
                        Product information
                    </Heading>
                    <Body size={14} weight="light">
                        Scan product barcodes to learn more about an item, plus
                        see offers and more.
                    </Body>
                </li>
                <li>
                    <IconQrCode />
                    <Heading type="h6" size={16}>
                        QR Code
                    </Heading>
                    <Body size={14} weight="light">
                        Dedicated web pages to learn more.
                    </Body>
                </li>
                <li>
                    <IconScanShipping height={24} width={24} />
                    <Heading type="h6" size={16}>
                        Shipment tracking
                    </Heading>
                    <Body size={14} weight="light">
                        Track your shipment, get updates on estimated delivery
                        and even earn points when you ship.
                    </Body>
                </li>
            </ul>
        </SwipeableDrawer>
    );
}

export default BarcodeInfoDrawer;
